import useSWR from 'swr'
import { getConfig } from '../environment'
import { AmplifyUserCtx, sampleUserContext } from '../user'

export const useFetchUserDetails = () => {
  // Use the same logic that was in HeaderProfile to determine the user context
  const userContext = getConfig().clientType === 'mock' ? sampleUserContext() : AmplifyUserCtx()

  return useSWR('/api/user-details', () => userContext.getUserDetails(), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })
}
